import { FormControlLabel, Switch, Typography } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"
import React, { useMemo } from "react"

import type { Contact } from "@/graphql/codegen/graphql"

interface UseSetNewPrimaryColumnsProps {
  selectedPrimaryContactId: string | null
  setSelectedPrimaryContactId: (contactId: string | null) => void
}

const useSetNewPrimaryColumns = ({
  selectedPrimaryContactId,
  setSelectedPrimaryContactId,
}: UseSetNewPrimaryColumnsProps): ColumnDef<Contact>[] => {
  return useMemo<ColumnDef<Contact>[]>(
    () => [
      {
        accessorKey: "firstName",
        header: "Contact Name",
        cell: ({ row }) => (
          <Typography variant='body2' className='text-gray-900'>
            {`${row.original.firstName} ${row.original.lastName}`}
          </Typography>
        ),
      },
      {
        accessorKey: "title",
        header: "Title",
        cell: ({ row }) => (
          <Typography variant='body2' className='text-gray-900'>
            {row?.original?.title}
          </Typography>
        ),
      },
      {
        accessorKey: "switcher",
        header: "",
        cell: ({ row }) => {
          const contactId = row.original.contactId as string
          return (
            <FormControlLabel
              control={
                <Switch
                  checked={row.original.contactId === selectedPrimaryContactId}
                  onChange={() => {
                    setSelectedPrimaryContactId(contactId === selectedPrimaryContactId ? null : contactId)
                  }}
                  size='small'
                />
              }
              label='Location Primary Contact'
            />
          )
        },
      },
    ],
    [selectedPrimaryContactId, setSelectedPrimaryContactId]
  )
}

export default useSetNewPrimaryColumns
